class RonsterTheme {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.currency = document.documentElement.lang || 'en-US';
    this.bindGlobal();
    this.bindProductForms();
    this.bindVariants();
    this.bindMedia();
    this.bindYoutubeVideos();
  }

  bindGlobal() {
    document.querySelectorAll('[data-mobile-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const open = menu.toggleAttribute('data-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('overflow-hidden', open);
    }));
    document.querySelectorAll('[data-mobile-menu-close]').forEach((button) => button.addEventListener('click', () => {
      document.querySelector('[data-mobile-menu]')?.removeAttribute('data-open');
      document.body.classList.remove('overflow-hidden');
    }));
    document.querySelectorAll('[data-search-open]').forEach((button) => button.addEventListener('click', () => document.querySelector('[data-search-dialog]')?.showModal()));
    document.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', () => document.querySelector('[data-search-dialog]')?.close()));
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', (event) => {
      if (!window.themeSettings?.ajaxCart) return;
      event.preventDefault(); this.openCart();
    }));
    document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', () => this.drawer?.close()));
    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-quantity-change]');
      if (!control) return;
      const input = control.parentElement.querySelector('input[type="number"]');
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(control.dataset.quantityChange));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  bindProductForms() {
    if (!window.themeSettings?.ajaxCart) return;
    document.querySelectorAll('form[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = true; submit.classList.add('is-loading');
      try {
        const response = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item');
        await this.openCart();
        this.toast('Added to your cart');
      } catch (error) { this.toast(error.message, true); }
      finally { submit.disabled = false; submit.classList.remove('is-loading'); }
    }));
  }

  bindVariants() {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const data = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
      const groups = [...root.querySelectorAll('[data-product-option]')];
      const update = () => {
        const selected = groups.map((group) => {
          const checked = group.querySelector('[data-option-control]:checked');
          const select = group.querySelector('[data-option-control]');
          return checked?.value || select?.value;
        });
        const variant = data.variants?.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        groups.forEach((group, index) => {
          const output = group.querySelector('[data-selected-option]');
          if (output) output.textContent = selected[index];
        });
        root.querySelectorAll('input[name="id"]').forEach((input) => input.value = variant.id);
        const price = root.querySelector('[data-product-price]');
        if (price) price.innerHTML = variant.compare_at_price > variant.price ? `<span class="visually-hidden">Regular price</span><s>${this.money(variant.compare_at_price)}</s><span class="visually-hidden">Sale price</span><span>${this.money(variant.price)}</span><em>Sale</em>` : `<span class="visually-hidden">Regular price</span><span>${this.money(variant.price)}</span>`;
        const button = root.querySelector('[data-add-button]');
        if (button) { button.disabled = !variant.available; button.querySelector('span').textContent = variant.available ? 'Add to cart' : 'Sold out'; }
        history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      };
      groups.forEach((group) => group.querySelectorAll('[data-option-control]').forEach((control) => control.addEventListener('change', update)));
    });
  }

  bindMedia() {
    document.querySelectorAll('[data-media-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      const root = thumb.closest('[data-product-media]');
      root.querySelectorAll('[data-media-item]').forEach((item) => item.hidden = item.dataset.mediaItem !== thumb.dataset.mediaThumb);
      root.querySelectorAll('[data-media-thumb]').forEach((item) => item.setAttribute('aria-current', item === thumb ? 'true' : 'false'));
    }));
  }

  bindYoutubeVideos() {
    document.querySelectorAll('[data-youtube-video]').forEach((container) => {
      const button = container.querySelector('button');
      button?.addEventListener('click', () => {
        const id = container.dataset.videoId || '';
        if (!/^[A-Za-z0-9_-]{8,}$/.test(id)) return;
        container.innerHTML = `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      });
    });
  }

  async openCart() {
    if (!this.drawer) return;
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    const body = this.drawer.querySelector('[data-cart-body]');
    const footer = this.drawer.querySelector('[data-cart-footer]');
    if (!cart.items.length) { body.innerHTML = '<p class="cart-empty">Your cart is empty</p>'; footer.hidden = true; }
    else {
      body.innerHTML = cart.items.map((item) => `<article class="drawer-item"><a href="${item.url}"><img src="${item.image || ''}" alt=""></a><div><a href="${item.url}"><strong>${item.product_title}</strong></a>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}<span>${this.money(item.final_line_price)} · Qty ${item.quantity}</span><button type="button" data-remove-key="${item.key}">Remove</button></div></article>`).join('');
      footer.hidden = false; footer.querySelector('[data-cart-total]').textContent = this.money(cart.total_price);
      body.querySelectorAll('[data-remove-key]').forEach((button) => button.addEventListener('click', async () => { await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: button.dataset.removeKey, quantity: 0 }) }); this.openCart(); }));
    }
    this.drawer.showModal();
  }

  money(cents) { return new Intl.NumberFormat(this.currency, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100); }
  toast(message, error = false) { const toast = document.querySelector('[data-toast]'); if (!toast) return; toast.textContent = message; toast.classList.toggle('is-error', error); toast.classList.add('is-visible'); clearTimeout(this.toastTimer); this.toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3200); }
}
document.addEventListener('DOMContentLoaded', () => new RonsterTheme());
